import React from 'react';
import MainLayout from '@/components/layout/MainLayout';
import { NotFoundState } from '@/components/common/NotFoundState';

export default function NotFoundPage() {
  return (
    <MainLayout>
      <NotFoundState />
    </MainLayout>
  );
}